import React from 'react';
import Icon from '../../../components/AppIcon';

const ExportHistoryTimeline = ({ history }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'success':
        return {
          icon: 'CheckCircle2',
          color: 'var(--color-success)',
          bgColor: 'bg-success/10',
          label: 'Sucesso'
        };
      case 'pending':
        return {
          icon: 'Clock',
          color: 'var(--color-warning)',
          bgColor: 'bg-warning/10',
          label: 'Pendente'
        };
      case 'failed':
        return {
          icon: 'XCircle',
          color: 'var(--color-error)',
          bgColor: 'bg-error/10',
          label: 'Falhou'
        };
      default:
        return {
          icon: 'Circle',
          color: 'var(--color-muted-foreground)',
          bgColor: 'bg-muted/30',
          label: 'Desconhecido'
        };
    }
  };

  const formatProcessingTime = (ms) => {
    if (ms < 1000) return `${ms}ms`;
    return `${(ms / 1000)?.toFixed(1)}s`;
  };

  if (!history || history?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
            <Icon name="History" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground">Histórico de Exportações</h3>
            <p className="text-xs text-muted-foreground">Operações recentes</p>
          </div>
        </div>
        <div className="text-center py-8">
          <Icon name="FileX" size={48} className="text-muted-foreground mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">Nenhuma exportação recente</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6 space-y-4">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
          <Icon name="History" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="font-semibold text-foreground">Histórico de Exportações</h3>
          <p className="text-xs text-muted-foreground">{history?.length} operações recentes</p>
        </div>
      </div>

      <div className="space-y-2 max-h-[400px] overflow-y-auto">
        {history?.map((item, index) => {
          const config = getStatusConfig(item?.status);

          return (
            <div 
              key={item?.id || index}
              className="p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-smooth"
            >
              <div className="flex items-start gap-3">
                <div className={`flex items-center justify-center w-8 h-8 rounded-md ${config?.bgColor}`}>
                  <Icon name={config?.icon} size={16} color={config?.color} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <p className="text-sm font-medium text-foreground truncate">
                      {item?.operation}
                    </p>
                    <span 
                      className="text-xs font-semibold"
                      style={{ color: config?.color }}
                    >
                      {config?.label}
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground truncate mb-2">
                    {item?.details}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-muted-foreground">
                    <span>
                      {new Date(item?.timestamp)?.toLocaleString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </span>
                    {item?.processingTime && (
                      <span>• {formatProcessingTime(item?.processingTime)}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ExportHistoryTimeline;